import {apiAddress} from "./APILink";

const getSubcategoryLinks = async (name) => {
    let response = await fetch(apiAddress + 'api/scripts/Subcategory.php?name=' + name, {method: 'get'});
    return await response.json();
}

export {getSubcategoryLinks};